var viewer_caption_default = {
  "fontElementMap": "qIhF-",
  "imageCaption": "_1lrvM"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
